export const GLOBAL = {
    url:	'http://ec2-54-218-201-71.us-west-2.compute.amazonaws.com:8080/portal_cloud_api/'
};



// WEBPACK FOOTER //
// ./src/app/services/global.ts